import Vue from "vue";
import VueRouter from "vue-router";

import base from "./modules/base";
import user from "./modules/user";
import teach from "./modules/teach";
import about from "./modules/about";
import course from "./modules/course";
import wallet from "./modules/wallet";
import setting from "./modules/setting";
import learing from "./modules/learing";
import contest from "./modules/contest";
import problem from "./modules/problem";
// import classBack from "./modules/classBack";
import courseBack from "./modules/courseBack";
import contestBack from "./modules/contestBack";
// import trainingBack from "./modules/trainingBack";
// import training from "./modules/training";
import blog from "./modules/blog";
import project from "./modules/project";
import problemBack from "./modules/problemBack";
import organization from "./modules/organization";
// import work from "./modules/work";
// import admin from "./modules/admin";

Vue.use(VueRouter)

// export default new VueRouter({
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/test',
      name: 'test',
      meta: { title: "测试" },
      component: () => import('@/views/test.vue')
    },
    {
      path: '/markdown',
      name: 'markdown',
      meta: { title: "测试" },
      component: () => import('@/views/markdown.vue')
    },
    ...base,
    ...user,
    ...teach,
    ...about,
    ...blog,
    ...project,
    ...wallet,
    ...course,
    ...setting,
    // ...training,
    ...learing,
    ...contest,
    ...problem,
    // ...classBack,
    // ...work,
    // ...admin,
    ...organization,
    ...problemBack,
    ...courseBack,
    ...contestBack,
    // ...trainingBack,
  ]
});

// 全局前置守卫：根据域名修改路由组件
router.beforeEach((to, from, next) => {
  const domain = window.location.hostname;

  // 找到首页路由配置（根据path匹配，而非索引）
  const homeRoute = router.options.routes.find(route => route.path === '/');

  if (homeRoute) {
    // 根据域名动态设置首页组件
    if (domain === 'www.doubao.com') {
      homeRoute.component = () => import('@/views/base/signin.vue');
    } else if (domain === 'www.baidu.com') {
      homeRoute.component = () => import('@/views/pages/home/index.vue');
    }

    // // 强制刷新路由缓存
    // if (to.name === 'home' && from.name !== 'home') {
    //   router.replace({ name: 'home' });
    // }
  }

  next();
});

export default router;

// https://www.cnblogs.com/zyulike/p/11190012.html
// https://www.cnblogs.com/maxiansheng/articles/11289355.html